// kvpIcons.tsx — Icon-Set für das Kontakt-Redesign (Ersatz für window.KVP_I
// aus den Designvorlagen). Schlichte Linien-SVGs im Refined-Classic-Stil
// (Strichstärke ~1.6–1.7, abgerundet). Rein dekorativ; keine Logik.

import * as React from "react";

const s = (children: React.ReactNode, size = 17): React.ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

export const I = {
  search: s(<><circle cx="9" cy="9" r="5.5" /><path d="M13.5 13.5L17 17" /></>),
  plus: s(<path d="M10 4v12M4 10h12" />),
  merge: s(<><path d="M6 3v4a4 4 0 004 4h4" /><path d="M11 8l3 3-3 3" /><circle cx="6" cy="3" r="1.6" /></>),
  edit: s(<path d="M13.5 3.5l3 3L7 16l-3.5.5L4 13z" />),
  trash: s(<path d="M4 5.5h12M7.5 5.5V3.5h5v2M6 5.5l.8 10.5h6.4L14 5.5" />),
  copy: s(<><rect x="7.5" y="2.5" width="10" height="10" rx="2.2" /><path d="M12.5 15.5A1.5 1.5 0 0111 17H5A1.5 1.5 0 013.5 15.5v-6A1.5 1.5 0 015 8" /></>),
  recycle: s(<><path d="M7 4.5l1.5-2h3L13 4.5" /><path d="M13 4.5l2.5 1.5-1 2.6M7 4.5L4.5 6l1.4 2.6M10 17.5l-2.5-1.5 1.2-2.4M10 17.5l2.5-1.5-1.2-2.4" /></>),
  phone: s(<path d="M7 3.8L4.5 4.1C3.5 7 5.3 10.7 7.8 13.2s6.2 4.3 9.1 3.3l.3-2.7-3.1-1.4-1.4 1.4a10 10 0 01-3.4-3.4l1.4-1.4z" />),
  // Mobil-/Smartphone-Icon — unterscheidet mobile Nummern von Festnetz.
  smartphone: s(<><rect x="6.2" y="2.4" width="7.6" height="15.2" rx="2" /><path d="M8.8 15.1h2.4" /></>),
  // Uhr-Icon — für Erreichbarkeit.
  clock: s(<><circle cx="10" cy="10" r="6.5" /><path d="M10 6.2V10l2.6 1.6" /></>),
  // Pfeil rechts — „zum Kontakt springen".
  arrowR: s(<path d="M4.5 10h10M10.5 5.8l4.2 4.2-4.2 4.2" />),
  mail: s(<><rect x="2.5" y="4.5" width="15" height="11" rx="2" /><path d="M3 6l7 5 7-5" /></>),
  // Sprechblase mit Ausrufezeichen — Melde-Knopf (Problem/Idee).
  feedback: s(<><path d="M4 4.5h12a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H9l-3.5 3v-3H4A1.5 1.5 0 0 1 2.5 13V6A1.5 1.5 0 0 1 4 4.5Z" /><path d="M10 7.5v3" /><path d="M10 12.6v.1" /></>),
  // Warndreieck mit Ausrufezeichen — der Melden-Knopf unten rechts.
  warnung: s(<><path d="M8.7 3.3 2.4 14.6A1.5 1.5 0 0 0 3.7 16.8h12.6a1.5 1.5 0 0 0 1.3-2.2L11.3 3.3a1.5 1.5 0 0 0-2.6 0Z" /><path d="M10 7.6v4" /><path d="M10 14.1v.1" /></>),
  // Glühbirne — Ticket-Art „Idee" (Gegenstück zu feedback/Problem).
  idee: s(<><path d="M10 2.8a5 5 0 0 0-3 9v2.2h6v-2.2a5 5 0 0 0-3-9Z" /><path d="M7.8 16.5h4.4" /></>),
  back: s(<path d="M12 5l-5 5 5 5M7 10h9" />),
  save: s(<><path d="M4.5 3.5h8L16.5 7v9.5A0 0 0 0116.5 16.5h-12A0 0 0 014.5 16.5z" /><path d="M6.5 3.5v4h6v-4M6.5 16.5v-5h7v5" /></>),
  share: s(<><circle cx="14.5" cy="4.5" r="2" /><circle cx="5.5" cy="10" r="2" /><circle cx="14.5" cy="15.5" r="2" /><path d="M7.3 9l5.4-3.6M7.3 11l5.4 3.6" /></>),
  chevD: s(<path d="M5.5 8l4.5 4.5L14.5 8" />, 14),
  check: (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7.5l3 3 5-6" />
    </svg>
  ),

  // ── Editor-Werkzeugleiste (RichTextEditor) ────────────────────────────────
  // Bewusst im selben Linien-Stil wie oben, damit die Fluent-freien Flächen
  // (Mail-Einstellungen) ohne @fluentui/react-icons auskommen.
  bold: s(<path d="M6 4h4.5a3 3 0 010 6H6zM6 10h5a3 3 0 010 6H6z" />),
  italic: s(<path d="M12.5 4h-4M11.5 16h-4M11 4L9 16" />),
  underline: s(<path d="M6 3.5V9a4 4 0 008 0V3.5M5 16.5h10" />),
  listUl: s(<><path d="M7.5 5.5h9M7.5 10h9M7.5 14.5h9" /><circle cx="4.3" cy="5.5" r="1.1" fill="currentColor" stroke="none" /><circle cx="4.3" cy="10" r="1.1" fill="currentColor" stroke="none" /><circle cx="4.3" cy="14.5" r="1.1" fill="currentColor" stroke="none" /></>),
  listOl: s(<><path d="M7.5 5.5h9M7.5 10h9M7.5 14.5h9" /><path d="M3.2 3.9h.9v3.2M3 12.1c0-1.4 2-1.2 2 0 0 .8-2 1.3-2 2.4h2.1" strokeWidth={1.3} /></>),
  link: s(<><path d="M8.4 11.6a3 3 0 004.2 0l2.3-2.3a3 3 0 10-4.2-4.2l-1 1" /><path d="M11.6 8.4a3 3 0 00-4.2 0l-2.3 2.3a3 3 0 104.2 4.2l1-1" /></>),
  image: s(<><rect x="2.8" y="4" width="14.4" height="12" rx="2" /><circle cx="7.2" cy="8.3" r="1.3" /><path d="M3.4 13.6l3.7-3.3 3 2.6 2.6-2.2 3.7 3.2" /></>),
  // Pinsel — „Format übertragen".
  brush: s(<><path d="M16.5 3.5l-6.8 7.4" /><path d="M9.7 10.9l-.8-.8c-1.6 0-2.9 1.2-3 2.8-.1 1.3-.7 2.2-1.9 2.8 2.4.8 5.1.4 6.3-1.1.8-1 .9-2.2.2-3z" /></>),
  // „T" mit Schrägstrich — „Formatierung löschen".
  clearFormat: s(<><path d="M4.5 4h9M9 4l-2.2 11" /><path d="M11.5 12.5l4 4M15.5 12.5l-4 4" /></>),
  settings: s(<><circle cx="10" cy="10" r="2.6" /><path d="M10 2.6v2M10 15.4v2M17.4 10h-2M4.6 10h-2M15.2 4.8l-1.4 1.4M6.2 13.8l-1.4 1.4M15.2 15.2l-1.4-1.4M6.2 6.2L4.8 4.8" /></>),
  close: s(<path d="M5.5 5.5l9 9M14.5 5.5l-9 9" />),
};

export type KvpIconKey = keyof typeof I;

// Kontakt-Typ-Icons (Firma/Person). Zentral hier, damit Tabelle und
// Detail-Header exakt dasselbe Icon verwenden.
export const FirmaIcon = (
  <svg width="17" height="17" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinejoin="round">
    <path d="M3 16V4.5L9 2.5l6 2V16" />
    <path d="M2 16h14M6 6.5h0M6 9.5h0M6 12.5h0M12 6.5h0M12 9.5h0M12 12.5h0" strokeLinecap="round" />
  </svg>
);
export const PersonIcon = (
  <svg width="17" height="17" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth={1.6}>
    <circle cx="9" cy="6" r="3" />
    <path d="M3.5 16c0-3 2.4-5 5.5-5s5.5 2 5.5 5" />
  </svg>
);
